import { styled } from "@mui/material";

interface Props {
  color: string;
}

export const Dot = styled('div')<Props>(({ color }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: color,
}));
